import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'

import { objectAttachments } from 'selectors/attachments'

import AttachmentCard from './AttachmentCard'

let select = (state, props) => ({
	attachments: objectAttachments(state, props)
})

export class AttachmentList extends Component {
	render(){
		let { props } = this
		return(
			<div style={{margin:props.attachments.length?"20px 0 20px 10px":"0", display:(!props.attachments.length && props.icon)?"none":"flex", flexWrap: "wrap"}}>
			{
			(props.attachments.length)?
				R.map(att => <AttachmentCard attachmentID={att._id} removable={props.removable} />, props.attachments)
				:null
			}
			</div>

		)
	}
}
export default connect(select)(AttachmentList)



// WEBPACK FOOTER //
// ./src/components/Attachments/AttachmentsList.js